import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/InterchangeScreenManufacturers'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class InterchangeScreenManufacturersStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "InterchangeScreenManufacturersStore",
			variables: false,
		})
	}
}

export async function load_InterchangeScreenManufacturers(params) {
  await initClient()

	const store = new InterchangeScreenManufacturersStore()

	await store.fetch(params)

	return {
		InterchangeScreenManufacturers: store,
	}
}
